import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@codex-brightworld/icons';
import { Tooltip } from '@codex-brightworld/basics';
import InformationTooltipRenderer from './InformationTooltipRenderer';

const StyledTooltip = styled(Tooltip)`
  position: absolute;
  left: 0px;
  top: ${(props) => (
    props.displayError ? '267px' : '214px'
  )}; 
  z-index: 10;
  padding: 14px 24px 24px 24px;
  background-color: #fff;
  display: ${(props) => (
    props.isDisplayed ? 'block' : 'none'
  )}; 
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    display: none;
  }
  
  border-radius: 10px;
  box-shadow: 0 0 6px 0 rgba(33, 48, 56, 0.2);
  border-color: ${(props) => props.theme.colors.neutral.grey[2]};
  border: 0px solid #CCCCCC;
  margin-bottom: 10px;
  
  div {
    left: 267px;
  }
  span {
    background-color: #fff;
  }
`;

const StyledAlertContent = styled.div`
    font-family: CurrysSans;
    font-size: 14px;
    color: #222222;  
    background-color: #fff;
`;

const StyledIconWrapper = styled.div`
  text-align: right;
  cursor: pointer;
  color: #4c12a1;
  padding-bottom: 10px;
`;

const StyledIcon = styled(Icon)`
    margin: -1px -2px 6px 0px;
    width: 16px;
    height: 10px;

  svg path:last-child {
    stroke: none;
    fill: ${(props) => props.theme.colors.primary.purple};
  }
`;

const StyledContent = styled.div`   
    p {
      margin: 0 0 7px 0;
    }
    li {
      margin: 0 0 7px 0;
    }
    a {
      color: ${(props) => props.theme.colors.primary.purple};
    }
`;

const InformationTooltip = ({
  tooltipHtml, isDisplayed, onCloseClick, displayError
}) => {
  const renderedHtml = InformationTooltipRenderer.getRenderedHtml(tooltipHtml);

  return (
    <StyledTooltip
      isDisplayed={isDisplayed}
      arrow={'top'}
      type={'info'}
      displayError={displayError}
    >
      <StyledAlertContent>
        <StyledIconWrapper onClick={onCloseClick}>
          Close
          {' '}
          <StyledIcon icon={'close'} />
        </StyledIconWrapper>
        <StyledContent>
          {renderedHtml}
        </StyledContent>
      </StyledAlertContent>
    </StyledTooltip>
  );
};

InformationTooltip.propTypes = {
  tooltipHtml: PropTypes.string.isRequired,
  isDisplayed: PropTypes.bool.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  displayError: PropTypes.bool.isRequired
};

export default InformationTooltip;
